import { Check, ArrowRight } from "lucide-react";
import X39Patch from "@/components/three/X39Patch";

const BENEFITS = [
  "Supports natural energy & stamina",
  "Promotes faster recovery & wound repair",
  "Enhances mental clarity & deep sleep",
  "Helps reduce inflammation markers",
  "Improves skin elasticity & appearance",
  "Drug-free, stimulant-free, non-invasive",
];

export default function Product() {
  return (
    <section
      id="product"
      data-testid="product-showcase-section"
      className="relative py-24 lg:py-32 overflow-hidden"
    >
      {/* Glow background */}
      <div className="absolute inset-0 -z-0">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full bg-[#00F0FF]/10 blur-[140px]" />
        <div className="absolute top-1/3 right-1/4 w-[400px] h-[400px] rounded-full bg-[#D900FF]/10 blur-[120px]" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        {/* 3D Patch */}
        <div className="lg:col-span-6 relative">
          <div className="relative aspect-square w-full max-w-[560px] mx-auto">
            <div className="absolute inset-0 rounded-full bg-[#00F0FF]/20 blur-[80px] floaty" />
            <div className="relative w-full h-full">
              <X39Patch />
            </div>
          </div>
          {/* Floating spec labels */}
          <div className="hidden md:block absolute top-12 left-0 glass-card px-4 py-3 text-left">
            <div className="text-label">Frequency</div>
            <div className="font-display font-bold text-lg mt-1">144 GHz</div>
          </div>
          <div className="hidden md:block absolute bottom-16 right-0 glass-card px-4 py-3 text-left">
            <div className="text-label">Wear time</div>
            <div className="font-display font-bold text-lg mt-1">12 hours</div>
          </div>
        </div>

        {/* Copy */}
        <div className="lg:col-span-6">
          <span className="text-label">∙ 02 / Product</span>
          <h2 className="mt-4 font-display font-black uppercase tracking-tighter text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
            The X39<sup className="text-[#00F0FF] text-2xl">™</sup>
            <br />
            <span className="text-[#00F0FF] glow-cyan">patch.</span>
          </h2>
          <p className="mt-6 text-white/70 leading-relaxed max-w-lg">
            A discreet phototherapy patch worn for up to 12 hours a day.
            Engineered to elevate the body's own copper peptide, GHK-Cu —
            associated with stem cell signalling, regeneration & vibrant skin.
          </p>

          <ul className="mt-8 grid sm:grid-cols-2 gap-3">
            {BENEFITS.map((b) => (
              <li
                key={b}
                className="flex items-start gap-3 text-sm text-white/80"
                data-testid={`benefit-${b.split(" ")[0].toLowerCase()}`}
              >
                <span className="mt-0.5 w-5 h-5 grid place-items-center border border-[#00F0FF]/50 bg-[#00F0FF]/10 flex-shrink-0">
                  <Check className="w-3 h-3 text-[#00F0FF]" strokeWidth={3} />
                </span>
                {b}
              </li>
            ))}
          </ul>

          <div className="mt-10 flex flex-wrap items-center gap-4">
            <a
              href="https://lifewave.com/shaykhshouse/store/products"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="product-cta-order"
              className="btn-neon group inline-flex items-center gap-3 px-7 py-4 bg-[#00F0FF] text-black font-mono-ui text-xs tracking-[0.3em] uppercase font-bold hover:bg-white hover:shadow-[0_0_30px_#00F0FF] transition-all"
            >
              Order Now
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
            </a>
            <div className="font-display">
              <div className="font-mono-ui text-[10px] tracking-[0.3em] uppercase text-white/40">
                Starting at
              </div>
              <div className="font-display font-black text-2xl">
                $149<span className="text-sm text-white/50 font-normal"> / month</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
